// useMeBalance.js
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import fetchMeBalance from '../action/fetchMeBalance.js';

import getMeData from '../selector/getMeData.js';
import getMeBalance from '../selector/getMeBalance.js';
import getNetworkingData from '../selector/getNetworkingData.js';

const meBalanceNetworkingSelectPath = ['fetch', 'balance'];

/**
 * Hook to fetch and get me balance.
 * @kind hook
 * @returns {{hasBalance: boolean, balance: number}} result - result object
 * @property {boolean} hasBalance - Whether the user has a balance
 * @property {number} balance - The user balance
 */
const useMeBalance = () => {
  const dispatch = useDispatch();

  const hasBalance = useSelector(state => getMeData(state, 'hasBalance'));
  const balance = useSelector(state => getMeBalance(state));
  const meId = useSelector(state => getMeData(state, 'id'));
  const isFetched = useSelector(state =>
    getNetworkingData(state, meBalanceNetworkingSelectPath, 'isFetched')
  );
  const isFetching = useSelector(state =>
    getNetworkingData(state, meBalanceNetworkingSelectPath, 'isFetching')
  );

  useEffect(() => {
    if (!hasBalance && !isFetching && !isFetched) {
      dispatch(fetchMeBalance());
    }
  }, [dispatch, hasBalance, isFetched, isFetching, meId]);

  return {
    hasBalance,
    balance,
  };
};

export default useMeBalance;
